<nf-table-layout
  [hideTitle]="true"
  [gridOptions]="gridOptions"
  [autoResizeGrid]="false"
  [data]="data"
  hideSearch
  hideClearAll
  *nfLoader="isLoading"
>
</nf-table-layout>
